import http from 'Support/services/HttpService';

class UseTermsRequest {
  static getTerms() {
    return http.get('/v1/termosUsoPoliticasPrivacidade');
  }

  static save(payload) {
    return http.put('/v1/termosUsoPoliticasPrivacidade', payload);
  }
}

export default UseTermsRequest;
